import React from "react";
import { useParams } from "react-router-dom";
import {
  t,
  translate,
} from "components/CentralDataMangement/translation/Translation";
import AccessControl from "components/common/services/RolesAndPermissions/AccessControl";
import FormBuilder from "components/common/services/form/FormBuilder";
import { validatePhoneNumber, validateSelectField } from "components/common/services/ValidationService";
import {
  ADD_WHATSAPP_USER,
  UPDATE_WHATSAPP_USER,
} from "routes/ApiEndpoints";
import { AJ_WEB_CONNECTOR } from "Constants";

const WhatsAppUserForm: React.FC = () => {
  const { id: userId } = useParams<{ id: string }>();

  // Validation rules for form fields
  const validationRules = {
    userName: [validateSelectField],
    mobNumber: [validatePhoneNumber],
    // userId is optional, so no validation
  };

  const permissionType = userId ? "update" : "create";
  const permissionObject = {
    permission: "Whatsapp account",
    [permissionType]: true,
  };

  return (
    <AccessControl
      requiredPermissions={[permissionObject]}
      renderNoAccess={true}
    >
      <FormBuilder
        // Dynamic title based on create or edit mode
        title={!userId ? t("Add user") : t("Edit user")}
        formName="WhatsAppUser"
        validationRules={validationRules}
        entryId={userId}
        // getDataAPI={CONF_SETTINGS_UPDATE_WHATSAPP_USER}
        SaveDataAPI={
          userId === undefined
            ? ADD_WHATSAPP_USER
            : UPDATE_WHATSAPP_USER
        }
        microService={AJ_WEB_CONNECTOR}
        backButton={true}
        redirect={-1} // Go back to previous page on success
        type="whatsapp-user"
      />
    </AccessControl>
  );
};

export default translate(WhatsAppUserForm);
